import React from 'react';
import CredentialImportStatusCard from './CredentialImportStatusCard';

class CredentialImportStatusCardBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('[CredentialImportStatusCard] render error', error);
    }
  }

  componentDidUpdate(prevProps) {
    const prevKey = prevProps.report?.report_id;
    const nextKey = this.props.report?.report_id;
    if (prevKey !== nextKey && this.state.hasError) {
      this.setState({ hasError: false });
    }
  }

  render() {
    const { report, theme, sourceDisplay } = this.props;

    if (this.state.hasError) {
      return null;
    }

    if (!report || (!report.import_provider && !report.import_source)) {
      return null;
    }

    if (!theme || !sourceDisplay) {
      return null;
    }

    return <CredentialImportStatusCard {...this.props} />;
  }
}

export default CredentialImportStatusCardBoundary;
